export enum ProjectDetailsViewMode {
  LIST = 'list',
  KANBAN = 'kanban'
}

export enum ProjectDetailTab {
  TASKS = 'tasks',
  NOTES = 'notes',
  MEMBERS = 'members',
  SETTINGS = 'settings'
}

export enum ProjectDetailFocus {
  DUE_DATE = 'due_date'
}

/** Projects page top-level surface: guidance vs full library vs day-by-day time forecast. */
export enum ProjectsListViewMode {
  FOCUS = 'focus',
  ALL = 'all',
  FORECAST = 'forecast'
}

/** A slice of a forecast day's stacked time bar. */
export enum ForecastSegmentKind {
  SLEEP = 'sleep',
  EVENTS = 'events',
  ROUTINES = 'routines',
  PROJECT = 'project',
  FREE = 'free'
}

/** Quick-setup templates for weekly capacity hours (Mon–Sun). */
export enum CapacityPresetId {
  FULL_WEEK_8 = 'full_week_8',
  WORKWEEK_8 = 'workweek_8',
  WORKWEEK_6 = 'workweek_6',
  LIGHT_4 = 'light_4',
  FULL_WEEK_4 = 'full_week_4'
}

export enum PortfolioBucket {
  ON_TRACK = 'on_track',
  AT_RISK = 'at_risk',
  CRITICAL = 'critical',
  NO_DEADLINE = 'no_deadline'
}

export enum PortfolioBadge {
  OVERCOMMITTED = 'overcommitted',
  START_NOW = 'start_now',
  SACRIFICE = 'sacrifice'
}

export enum PortfolioImportance {
  LOW = 1,
  MEDIUM = 2,
  HIGH = 3,
  CRITICAL = 4
}

export enum PortfolioActionSection {
  ASK_FOR_EXTENSION = 'ask_for_extension',
  START_NOW = 'start_now',
  BACK_BURNER = 'back_burner'
}

/** Whole-project lifecycle state (distinct from per-task custom statuses). */
export enum ProjectLifecycleStatus {
  ACTIVE = 'active',
  COMPLETED = 'completed',
  ARCHIVED = 'archived'
}

export enum ProjectInviteProcessStatus {
  INVALID = 'invalid',
  WRONG_ACCOUNT = 'wrong_account',
  READY = 'ready'
}

export enum ProjectInviteStatusVariant {
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error'
}
